import { reactive } from "vue";

export const loadingState = reactive({
  isLoading: false,
  activeRequests: 0,
});

export const showLoading = () => {
  loadingState.activeRequests++;
  loadingState.isLoading = true;
};

export const hideLoading = () => {
  if (loadingState.activeRequests > 0) {
    loadingState.activeRequests--;
  }

  if (loadingState.activeRequests === 0) {
    loadingState.isLoading = false;
  }
};
